export function getUnpaidDetailsEndpoint(): string {
    return '/unpaidDetails';
}
